import { useMemo } from "react";
import isEmpty from "lodash/isEmpty";
import usePluggableEventActions from "components/events/events/hooks/usePluggableEventActions";
const useEventBulkAction = (events, onEventCallback) => {
  const { actions: pluggableActions, actionModals: pluggableActionModals } = usePluggableEventActions(
    events,
    true,
    onEventCallback
  );
  const actions = useMemo(() => pluggableActions.filter(Boolean), [pluggableActions]);
  if (isEmpty(actions)) return { actions: null, pluggableActionModals: null };
  return { actions, pluggableActionModals };
};
export default useEventBulkAction;
